import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'
import './js/BootstrapVue.js'
import './js/FontAwesome'
import './js/VueLidate'
import DashboardLayout from '@/layouts/DashboardLayout'
import LoginLayout from '@/layouts/LoginLayout'
import VueCurrencyInput from 'vue-currency-input'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import '@/styles/PdfExportProgress.scss';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)


Vue.prototype.$notifications = [];

Vue.component('dashboard-layout', DashboardLayout);
Vue.component('login-layout', LoginLayout);

Vue.use(VueCurrencyInput)
Vue.use(VueTheMask)
Vue.use(Loading, { color: '#f2671c' });

Vue.config.productionTip = false

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
